import { render, staticRenderFns } from "./POIAdmin.vue?vue&type=template&id=0d800537"
import script from "./POIAdmin.js?vue&type=script&lang=js&external"
export * from "./POIAdmin.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports